import apiUser from "../../apiUser";
import apiPlatform from "../../apiPlatform";
import {setWorkers} from "../workers/actions";
import {setVats} from "../vats/actions";
import {setWorkplaces} from "../workplaces/actions";
import {setRepairOrderStatuses} from "../repairOrderStatuses/actions";

export const SET = 'workshop/SET';
export const WORKSHOP_PLAN_UPDATE = 'workshop/workshopPlan/UPDATE';
export const WORKSHOP_PRODUCT_PRICE_GROUP_UPDATE = 'workshop/workshopProductPriceGroup/UPDATE';
export const WORKSHOP_PRODUCT_PRICE_GROUP_ADD = 'workshop/workshopProductPriceGroup/ADD';
export const WORKSHOP_CALENDAR_ADD = 'workshop/workshopCalendar/ADD';
export const WORKSHOP_CALENDAR_UPDATE = 'workshop/workshopCalendar/UPDATE';
export const WORKSHOP_CALENDAR_DELETE = 'workshop/workshopCalendar/DELETE';
export const WORKSHOP_CASH_BOX_ADD = 'workshop/workshopCashBox/ADD';
export const WORKSHOP_CASH_BOX_UPDATE = 'workshop/workshopCashBox/UPDATE';
export const WORKSHOP_CASH_BOX_DELETE = 'workshop/workshopCashBox/DELETE';
export const WORKSHOP_PLAN_SMS_AVAILABLE_COUNT_SET = 'workshopPlan/smsAvailableCount/SET';
export const WORKSHOP_WORKSHOP_PLAN_VEHICLE_BY_REG_NUMBER_COUNT_UPDATE = 'workshop/workshopPlan/vehicleByRegNumberCount/UPDATE';
export const WORKSHOP_INTEGRATION_UPDATE = 'workshop/integration/UPDATE';
export const WORKSHOP_BSX_AUTH_UPDATE = 'workshop/bsxAut/UPDATE';

export function setWorkshop(value) {
  return {
    type: SET,
    value
  }
}
export function workshopPlanUpdated(workshopPlan) {
  return {
    type: WORKSHOP_PLAN_UPDATE,
    workshopPlan
  }
}

export function workshopProductPriceGroupCreated(workshopProductPriceGroup) {
  return {
    type: WORKSHOP_PRODUCT_PRICE_GROUP_ADD,
    workshopProductPriceGroup
  }
}

export function workshopProductPriceGroupUpdated(workshopProductPriceGroup) {
  return {
    type: WORKSHOP_PRODUCT_PRICE_GROUP_UPDATE,
    workshopProductPriceGroup
  }
}

export function workshopCalendarCreated(calendar) {
  return {
    type: WORKSHOP_CALENDAR_ADD,
    calendar
  }
}

export function workshopCalendarUpdated(calendar) {
  return {
    type: WORKSHOP_CALENDAR_UPDATE,
    calendar
  }
}

export function workshopCalendarDeleted(calendarId) {
  return {
    type: WORKSHOP_CALENDAR_DELETE,
    calendarId
  }
}

export function workshopCashBoxCreated(cashBox) {
  return {
    type: WORKSHOP_CASH_BOX_ADD,
    cashBox
  }
}

export function workshopCashBoxUpdated(cashBox) {
  return {
    type: WORKSHOP_CASH_BOX_UPDATE,
    cashBox
  }
}

export function workshopCashBoxDeleted(cashBoxId) {
  return {
    type: WORKSHOP_CASH_BOX_DELETE,
    cashBoxId
  }
}

export function workshopPlanSmsAvailableCount(smsAvailableCount) {
  return {
    type: WORKSHOP_PLAN_SMS_AVAILABLE_COUNT_SET,
    smsAvailableCount
  }
}

export const createWorkshop = () => dispatch => apiUser.user.createWorkshop().then(res => {
  dispatch(setWorkshop(res.data.workshop))
  dispatch(setWorkers(res.data.workshop.workers))
  dispatch(setVats(res.data.vats))
  dispatch(setWorkplaces(res.data.workplaces))
  dispatch(setRepairOrderStatuses(res.data.repairOrderStatuses))

  return res
})


export function updateWorkshop(data){
  return dispatch => {
    return apiUser.workshop.patch(data)
    .then(workshop => {
      dispatch(setWorkshop(workshop));

      return workshop;
    })
  }
}

export function createWorkshopProductPriceGroups(data){
  return dispatch => {
    return apiUser.workshopProductPriceGroups.post(data)
    .then(workshopProductPriceGroup => {
      dispatch(workshopProductPriceGroupCreated(workshopProductPriceGroup));

      return workshopProductPriceGroup;
    })
  }
}

export function updateWorkshopProductPriceGroups(id, data){
  return dispatch => {
    return apiUser.workshopProductPriceGroups.patch(id, data)
    .then(workshopProductPriceGroup => {
      dispatch(workshopProductPriceGroupUpdated(workshopProductPriceGroup));

      return workshopProductPriceGroup;
    })
  }
}

export function createWorkshopCalendar(data){
  return dispatch => {
    return apiUser.calendars.post(data)
    .then(calendar => {
      dispatch(workshopCalendarCreated(calendar));

      return calendar;
    })
  }
}

export function updateWorkshopCalendar(id, data){
  return dispatch => {
    return apiUser.calendars.patch(id, data)
    .then(calendar => {
      dispatch(workshopCalendarUpdated(calendar));

      return calendar;
    })
  }
}

export function deleteWorkshopCalendar(id){
  return dispatch => {
    return apiUser.calendars.delete(id)
    .then(calendar => {
      dispatch(workshopCalendarDeleted(id));

      return calendar;
    })
  }
}

export function createWorkshopCashBox(data){
  return dispatch => {
    return apiPlatform.cashBoxes.create(data)
    .then(res => {
      dispatch(workshopCashBoxCreated(res.data));

      return res.data;
    })
  }
}

export function updateWorkshopCashBox(data){
  return dispatch => {
    return apiPlatform.cashBoxes.update(data)
    .then(res => {
      dispatch(workshopCashBoxUpdated(res.data));

      return res.data;
    })
  }
}

export function updateWorkshopPlanSmsAvailableCount(){
  return dispatch => {
    return apiPlatform.workshopPlans.getSmsAvailableCount()
      .then(res => {
        dispatch(workshopPlanSmsAvailableCount(res.data))
      })
      .catch();
  }
}

export function deleteWorkshopCashBox(id){
  return dispatch => {
    return apiPlatform.cashBoxes.delete(id)
    .then(() => {
      dispatch(workshopCashBoxDeleted(id));

      return id;
    })
  }
}

export function workshopPlanVehicleByRegNumberCountUpdate(vehicleByRegNumberCount) {
  return dispatch => dispatch({
      type: WORKSHOP_WORKSHOP_PLAN_VEHICLE_BY_REG_NUMBER_COUNT_UPDATE,
      vehicleByRegNumberCount
    }
  )}

export function workshopIntegrationUpdate(integration) {
  return dispatch => dispatch({
      type: WORKSHOP_INTEGRATION_UPDATE,
      integration
    })
}